import { haystackMatchesCommaSearch } from "@/lib/manufacturing/commaDelimitedSearch";
import type { MfgMaterialUse } from "@/lib/manufacturing/types";

export type MaterialUsesActiveFilter = "active" | "inactive" | "all";

/** `all` = any channel; `none` = substitute / null channel; else exact finish_channel. */
export type MaterialUsesChannelFilter = "all" | "none" | string;

export function filterManufacturingMaterialUses(
  uses: readonly MfgMaterialUse[],
  opts: {
    search: string;
    activeFilter: MaterialUsesActiveFilter;
    channelFilter: MaterialUsesChannelFilter;
    memberSearchByUseId?: Readonly<Record<string, string>>;
  },
): MfgMaterialUse[] {
  const memberIndex = opts.memberSearchByUseId ?? {};
  return uses.filter((u) => {
    if (opts.activeFilter === "active" && !u.is_active) return false;
    if (opts.activeFilter === "inactive" && u.is_active) return false;

    if (opts.channelFilter === "none") {
      if (u.finish_channel) return false;
    } else if (opts.channelFilter !== "all") {
      if ((u.finish_channel || "").toLowerCase() !== opts.channelFilter.toLowerCase()) {
        return false;
      }
    }

    const hay = [
      u.use_code,
      u.name,
      u.notes,
      u.finish_channel ?? "",
      u.resolve_mode,
      memberIndex[u.id] ?? "",
    ].join(" ");
    return haystackMatchesCommaSearch(hay, opts.search);
  });
}

export function distinctFinishChannels(uses: readonly MfgMaterialUse[]): string[] {
  const set = new Set<string>();
  for (const u of uses) {
    const ch = (u.finish_channel || "").trim().toLowerCase();
    if (ch) set.add(ch);
  }
  return [...set].sort();
}
